import React from 'react';
import FilterGroupSearch from './FilterGroupSearch';

const SearchFilterGroupContainer = ({
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setSelectedFilterGroupCode,
  setFilterGroupCode,
  setRecordFormatFilterGroupId,
}) => {
  return (
    <>
      <FilterGroupSearch
        setRecordFormatFilterGroupId={setRecordFormatFilterGroupId}
        setFilterGroupCode={setFilterGroupCode}
        setTabValue={setTabValue}
        setSelectedFilterGroupCode={setSelectedFilterGroupCode}
        handleClose={handleClose}
        setRecordFormatFilterGroupCode={setRecordFormatFilterGroupCode}
      />
    </>
  );
};
export default SearchFilterGroupContainer;
